import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Modal } from '../../../components/Modal';
import { fetchInvoice } from '../../Invoices/actions';
import { selectWork } from '../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import { GeneratePdfButton } from '../../../components/GeneratePdfButton/GeneratePdfButton';
import { HBox, VBox } from '../../../components/Box';
import { selectAllOptions } from '../selectors';
import { PickUpStatementDoc } from './PickUpStatementDoc';
import { REQUEST_INVOICE } from '../../Invoices/constants';
import { Loader } from '../../../components/Loader';
import { selectAddressTypes } from '../../Address/selectors';
import { Flag } from '../../../containers/App/LanguageSelection';

const Container = styled.div`
  font-size: 14px;
  margin: 10px auto;
  margin-bottom: 50px;

  width: 1240px;
  height: 1754px;
  background-color: white;
  color: black;

  .doc-main {
    color: black;
    font-weight: 600;
    padding: 150px 150px 75px 150px;
  }

  .title {
    font-size: 45px;
  }


  .vehicle-info-section {
    font-size: 24px;
    margin-bottom: 36px;
  }

  .options-section {
    font-size: 24px;
    margin-bottom: 100px;
  }

  .b2b-price-section {
    align-items: baseline;
    margin-bottom: 48px;
  }

  .price-incl-options {
    width: 40%;
    font-size: 20px;
    margin-bottom: 50px;
  }
`;

const Selection = styled.div`
  display: flex;
  cursor: pointer;

  img {
    width: 50px;
    height: 50px;
  }
  .flag {
    text-align: center;
    margin: 12px;
    border-radius: 40px;
    overflow: hidden;
    width: 60px;
    height: 60px;
  }
`;

const STATE = {
  selectedLanguage: null,
};

/* eslint-disable react/prefer-stateless-function */
class PickUpStatementPdfPreviewComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetchInvoice(result => {});
  }

  render() {
    const vehicle = this.props.vehicle;
    if (this.props.work)
      return (
        <Modal>
          <HBox center>
            <Loader />
          </HBox>
        </Modal>
      );
    return (
      <Modal pdfView onClose={this.props.onClose}>
        <VBox>
          <strong>{this.lbl('vehicle.details.pickup_statement.select_language')}</strong>
          <HBox left vCenter>
            <Selection>
              {['nl', 'de', 'en'].map(locale => (
                <Flag
                  className="flag"
                  key={locale}
                  onClick={this.setStateFn({ selectedLanguage: locale })}
                  src={`/public/images/${locale}.svg`}
                />
              ))}
            </Selection>
          </HBox>
        </VBox>
        <Container>
          {this.state.selectedLanguage && (
            <VBox id={'Pick_up_statement_doc'}>
              <PickUpStatementDoc
                vehicle={vehicle}
                outgoingInvoiceId={vehicle?.outgoing_invoice}
                language={this.state.selectedLanguage}
              />
            </VBox>
          )}
        </Container>
        {this.state.selectedLanguage && (
          <GeneratePdfButton generateDirectly sectionId={'Pick_up_statement_doc'} label={'PDF'} widthMn={210} heightMm={297} />
        )}
      </Modal>
    );
  }
}

PickUpStatementPdfPreviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loadingChecks: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    work: selectWork(REQUEST_INVOICE),
    allOptions: selectAllOptions(),
    addressTypes: selectAddressTypes(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchInvoice(callback) {
      dispatch(fetchInvoice(ownProps?.vehicle?.outgoing_invoice, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const PickUpStatementPdfPreview = compose(withConnect, withRouter)(PickUpStatementPdfPreviewComp);
